<template>
  <gl-page icon-name="gr-farm" :title="title">
    <div class="contentMain">
      <blocks-history class="contentMain__history" />
    </div>
  </gl-page>
</template>

<script>
import GlPage from '@gl/GlPage'
import BlocksHistory from '@/components/Blocks/BlocksHistory'

export default {
  name: 'Main',
  components: {
    BlocksHistory,
    GlPage,
  },
  computed: {
    title() {
      const id = this.$route?.params?.id
      return id ? `Block history #${id}` : `Block history`
    },
  },
}
</script>

<style lang="scss" scoped>
.contentMain {
  @include grid;

  &__history {
    grid-column: 1 / -1;

    @media (min-width: $breakpoint-lg) {
      grid-column: 1 / -1;
    }
  }

  &__transactions {
    grid-column: 1 / -1;

    @media (min-width: $breakpoint-lg) {
      grid-column: 1 / 7;
    }
  }

  &__summary {
    grid-column: 1 / -1;

    @media (min-width: $breakpoint-lg) {
      grid-column: 7 / 13;
    }
  }
}
</style>
